import { useNavigate } from "react-router-dom";
import { CreateInvoicePage as CreateInvoicePageView } from "@/components/CreateInvoicePage";

export function CreateInvoicePage() {
  const navigate = useNavigate();

  return (
    <CreateInvoicePageView
      onCreated={(id) => navigate(`/invoices/${id}`)}
      onCancel={() => navigate("/invoices")}
    />
  );
}
